import { Performance as PerformanceIcon } from '@tunasong/icons'
import type { Entity, Persisted } from '@tunasong/schemas'
import { IconButton, Tooltip, useNavigateToEntity } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './perform-button.module.css'

export interface PerformButtonProps {
  entity: Persisted<Entity>
  /** Phone: a 44px target; otherwise 32px */
  compact: boolean
}

/** The song plugin's layout; the song page's Perform button and "Enter Performance Mode" open the same one */
const performanceLayout = 'Performance'

/**
 * Opens a song straight in its Performance layout, as the song page's Perform does. Parts resolve inside the
 * layout (per user, per band), so they behave the same from here. Never disabled: offline, a cached song opens.
 *
 * A quiet neutral icon at every size: a labelled button on each song row crowded out the row's context. It stays
 * visible at rest (no hover-only affordance) and names itself in a tooltip.
 */
export const PerformButton: FC<PerformButtonProps> = props => {
  const { entity, compact } = props
  const navigateToEntity = useNavigateToEntity()
  const label = `Perform ${entity.name ?? 'song'}`
  const handleClick = () => navigateToEntity(entity, { layout: performanceLayout })

  return (
    <Tooltip title="Perform" enterDelay={300}>
      <IconButton className={compact ? styles.performCompact : styles.perform} aria-label={label} onClick={handleClick}>
        <PerformanceIcon />
      </IconButton>
    </Tooltip>
  )
}
